export default "/static/dashboard/build/app/img/v2/461f7599f2e6ecd65bb1d7b9fce8aa91.png";